import { Component, ViewEncapsulation, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { CartService } from '../../../services/cart.service';
import { CartRow } from '../../../interfaces/cart.model';
import { EditPriceDialog, EditPriceDialogResult } from '../edit-price-dialog/edit-price-dialog';

@Component({
  selector: 'prd-cart-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatDividerModule,
    TranslocoCurrencyPipe,
  ],
  templateUrl: './cart-dialog.html',
  styleUrl: './cart-dialog.scss',
  // Necessario per stilizzare il pannello dell'overlay (.cart-panel),
  // che sta fuori dal DOM del componente
  encapsulation: ViewEncapsulation.None,
})
export class CartDialog {
  private dialogRef = inject(MatDialogRef<CartDialog>);
  private dialog = inject(MatDialog);
  private cartService = inject(CartService);

  protected cart = this.cartService.cart;

  // Righe del carrello attivo, escluse quelle archiviate
  protected rows = computed(() =>
    (this.cartService.cart()?.righe ?? []).filter(row => !row.archiviata)
  );

  onClose() {
    this.dialogRef.close();
  }

  increment(row: CartRow) {
    this.updateQuantity(row, row.quantita + 1);
  }

  decrement(row: CartRow) {
    if (row.quantita > 1) {
      this.updateQuantity(row, row.quantita - 1);
    }
  }

  // Quantità 0 = il backend elimina la riga dal carrello
  remove(row: CartRow) {
    this.updateQuantity(row, 0);
  }

  editPrice(row: CartRow) {
    this.dialog.open(EditPriceDialog, {
      width: '400px',
      data: {
        nomeProdotto: row.nomeProdotto,
        prezzo: row.prezzo,
        unitaMisura: row.unitaMisura,
      },
    }).afterClosed().subscribe((result?: EditPriceDialogResult) => {
      if (result) {
        this.cartService.updateProduct(row.idProdotto, row.quantita, result.price).subscribe({
          error: error => {
            console.error('Errore durante l\'aggiornamento del prezzo', error);
          },
        });
      }
    });
  }

  clearCart() {
    this.cartService.clearCart().subscribe({
      error: error => {
        console.error('Errore durante lo svuotamento del carrello', error);
      },
    });
  }

  private updateQuantity(row: CartRow, quantity: number) {
    this.cartService.updateProduct(row.idProdotto, quantity, row.prezzo).subscribe({
      error: error => {
        console.error('Errore durante l\'aggiornamento della quantità', error);
      },
    });
  }
}
